import { PayTuitionQuery } from '../queries/pay_tuition_query';

export class PayTuitionFacade {
  constructor(private $window: any, private ngPayTuitionQuery: PayTuitionQuery) {}

  onPayTuitionTriggerEnded() {
    this.$window.open(this.ngPayTuitionQuery.result.payTuitionURL, '_blank');
  }
}

angular.module('capability-ng-scheduler').service('ngPayTuitionFacade', PayTuitionFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/pay_tuition_facade.ts